import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import { setNextStep } from "../../../../redux/shared/actions";
import { getQuiz, assignQuiz } from "../../../../redux/educator/actions";
import {
  selectQuizzes,
  selectQuizzesLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  quizzes: selectQuizzes(state),
  loading: selectQuizzesLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      setNextStep,
      assignQuiz,
      getQuiz,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
